export const vesselTypes = [
  "Crude Oil Tanker",
  "Oil Products Tanker",
  "Crude/Oil Products Tanker",
  "Chemical/Oil Products Tanker",
  "Chemical Tanker",
  "FPSO",
  "FSO",
  "FSRU",
  "OBO",
  "O/O",
  "Asphalt/Bitumen Tanker",
  "Bunkering Tanker",
  "LPG",
  "LNG",
  "Tug",
  "Barge",
  "ATB",
  "AHT",
  "AHTS",
  "Multi Purpose Offshore Vessel",
  "Platform Supply Vessel",
  "Bulk Carrier",
  "Caustic Soda/Bulk Carrier",
  "Container Ship",
  "General Cargo Ship",
  "Pure Car Carrier",
  "Pure Car and Truck Carrier",
  "Heavy Load Carrier",
  "CO2 Tanker",
  "Caprolactam",
];
export const otherVesselTypes = [
  "Bulkcarrier",
  "Log bulkcarrier",
  "Grabfitted bulkcarrier",
  "Grabfitted Log bulkcarrier",
  "Boxshaped bulkcarrier",
  "Boxshaped Log bulkcarrier",
  "Boxshaped Grabfitted bulkcarrier",
  "Boxshaped Grabfitted Log bulkcarrier",
  "Openhatch boxshaped bulkcarrier",
  "Openhatch boxshaped grabfitted bulkcarrier",
  "Semi boxshaped bulkcarrier",
  "Semi boxshaped log bulkcarrier",
  "Semi boxshaped grabfitted bulkcarrier",
  "Semi boxshaped grabfitted log bulkcarrier",
];
